export enum TopicTypeEnum {
  TelemetryAlarm = 'TelemetryAlarm',
  ContractExpiration = 'ContractExpiration',
  LicenseExpiration = 'LicenseExpiration',
  Maintenance = 'Maintenance',
  //
}
export enum AdminTopicTypeEnum {
  Cc3GenericNotificationTsc = 'Cc3GenericNotificationTsc',
}

//-------------------------------------------------------------------------------------------------
// DTO
//-------------------------------------------------------------------------------------------------
export interface EventOccurranceDto {
  occurredAt: Date;
  occurredWith: string[] | null;
}

export interface TopicEventDto {
  subEventId: string;
  occurrances: EventOccurranceDto[];
}

export interface IncomingTopicsDto {
  aggregateId: string;
  aggregateType: string;

  acknowledgedAt: Date | null;
  acknowledgedBy: string | null;
  acknowledgedSubEvents: string[] | null;

  createdAt: Date;
  createdBy: string;
  customerId: string | null;
  dueAt: Date | null;
  expiresAt: Date | null;
  machineId: string;
  open: boolean;
  source: string;

  status: string;
  subEvents: TopicEventDto[];
  topicType: string;
  updatedAt: Date | null;
  updatedBy: string | null;
  workshopId: string;
}

//-------------------------------------------------------------------------------------------------
// STO
//-------------------------------------------------------------------------------------------------
export class IncomingTopicsSto {
  aggregateId: string;
  aggregateType: string;

  acknowledgedAt: Date | null;
  acknowledgedBy: string | null;
  acknowledgedSubEvents: string[] | null;

  createdAt: Date;
  createdBy: string;
  customerId: string | null;
  dueAt: Date | null;
  expiresAt: Date | null;
  machineId: string;
  open: boolean;
  source: string;

  status: string;
  subEvents: TopicEventDto[];
  topicType: string;
  updatedAt: Date | null;
  updatedBy: string | null;
  workshopId: string;

  constructor(dto: IncomingTopicsDto) {
    this.aggregateId = dto?.aggregateId;
    this.aggregateType = dto?.aggregateType;

    this.acknowledgedAt = dto?.acknowledgedAt;
    this.acknowledgedBy = dto?.acknowledgedBy;
    this.acknowledgedSubEvents = dto?.acknowledgedSubEvents;

    this.createdAt = dto?.createdAt;
    this.createdBy = dto?.createdBy;
    this.customerId = dto?.customerId;
    this.dueAt = dto?.dueAt;
    this.expiresAt = dto?.expiresAt;
    this.machineId = dto?.machineId;
    this.open = dto?.open;
    this.source = dto?.source;
    this.status = dto?.status;

    this.subEvents = dto?.subEvents;
    this.topicType = dto?.topicType;
    this.updatedAt = dto?.updatedAt;
    this.updatedBy = dto?.updatedBy;
    this.workshopId = dto?.workshopId;
  }
}

/**
 *
 */
export class IncomingTopicTableRow {
  // Columns
  rowId: string;
  colStatus: string;
  colCreatedAt: Date;
  colDueAt: Date | null;
  colSource: string;
  colType: string;
  colCustomer: string | null;
  colSerial: string;
  colMachine: string;
  colWorkshop: string;
  colDescription: string;
  colMaxiCare: Date | null;

  // administrative
  showCreateJobButton?: boolean | null;
  topicObject: IncomingTopicsSto;
  relatedWorkshop: RelatedWorkshopSto;
  relatedCustomer?: RelatedCustomerSto;
  relatedMachine: RelatedMachineSto;

  constructor(
    sto: IncomingTopicsSto,
    relatedCustomer: RelatedCustomerSto,
    relatedMachine: RelatedMachineSto,
    relatedWorkshop: RelatedWorkshopSto,
    description?: string,
    label?: string
  ) {
    this.rowId = sto?.aggregateId;
    this.colStatus = sto?.status;
    this.colCreatedAt = sto?.createdAt;
    this.colDueAt = sto?.dueAt;
    this.colSource = sto?.source;
    this.colType = label;
    this.colCustomer = relatedCustomer?.name + relatedCustomer?.aggregateId;
    this.colSerial = relatedMachine?.serial;
    this.colMachine = relatedMachine?.name + relatedMachine?.serial;
    this.colWorkshop = relatedWorkshop?.name + relatedWorkshop?.aggregateId;
    this.colDescription = description;
    this.colMaxiCare = relatedMachine?.maxiCareEndDate ? new Date(relatedMachine.maxiCareEndDate) : null;
    this.topicObject = sto;
    this.relatedMachine = relatedMachine;
    this.relatedCustomer = relatedCustomer;
    this.relatedWorkshop = relatedWorkshop;
  }
}

export class RelatedObjectSto {
  aggregateType: string;
  aggregateId: string;
  constructor(aggregateType: string, aggregateId: string) {
    this.aggregateType = aggregateType;
    this.aggregateId = aggregateId;
  }
}

export interface RelatedMachineDto {
  aggregateType: string;
  aggregateId: string;
  serial: string;
  brandId: string;
  name: string;
  productFamily: string;
  maxiCareEndDate: Date | null;
  type: string;
  subtype: string;
}

export class RelatedMachineSto extends RelatedObjectSto {
  serial: string;
  brandId: string;
  name: string;
  productFamily: string;
  maxiCareEndDate: Date | null;
  type: string;
  subtype: string;

  constructor(dto: RelatedMachineDto) {
    super(dto?.aggregateType, dto?.aggregateId);
    this.aggregateId = dto?.aggregateId;
    this.aggregateType = dto?.aggregateType;
    this.serial = dto?.serial;
    this.brandId = dto?.brandId;
    this.name = dto?.name;
    this.productFamily = dto?.productFamily;
    this.maxiCareEndDate = dto?.maxiCareEndDate;
    this.type = dto?.type;
    this.subtype = dto?.subtype;
  }
}

export interface RelatedWorkshopDto {
  aggregateType: string;
  aggregateId: string;
  name: string;
  name2: string;
}

export class RelatedWorkshopSto extends RelatedObjectSto {
  name: string;
  name2: string;

  constructor(dto: RelatedWorkshopDto) {
    super(dto?.aggregateType, dto?.aggregateId);
    this.name = dto?.name;
    this.name2 = dto?.name2;
  }
}

export interface RelatedCustomerDto {
  aggregateType: string;
  aggregateId: string;
  customerId: string;
  name: string;
  name2: string;
}

export class RelatedCustomerSto extends RelatedObjectSto {
  customerId: string;
  name: string;
  name2: string;

  constructor(dto: RelatedCustomerDto) {
    super(dto?.aggregateType, dto?.aggregateId);
    this.customerId = dto?.customerId;
    this.name = dto?.name;
    this.name2 = dto?.name2;
  }
}

export interface AcknowledgeRequestDto {
  subEventIds: string[];
  dismissed: boolean;
}

export class DtcOccurranceSelectedEvent {
  occurredAt: Date;
  operationHours: number;
  severityLevel: number;
  latitude: number | null;
  longitude: number | null;
  altitude: number | null;

  constructor(occ: EventOccurranceDto) {
    this.occurredAt = occ?.occurredAt;
    this.operationHours = parseFloat(occ?.occurredWith[0]);
    this.severityLevel = parseInt(occ?.occurredWith[1]);
    this.latitude = parseFloat(occ?.occurredWith[2]);
    this.longitude = parseFloat(occ?.occurredWith[3]);
    this.altitude = parseFloat(occ?.occurredWith[4]);
  }
}
